// POS sistem-bildiriş store-u — lokal (localStorage), qalıcı.
//
// Bildirişlər səhifəsi ([pages/GenelAyarlar.tsx]) garson/mətbəx bildirişlərini
// cloud poll-undan qurur və hər poll-da state-i tam əvəz edir. POS-spesifik
// "sistem" bildirişləri (məs. admin qiymət dəyişikliyi → catalogNotify) cloud-da
// olmadığı üçün burada — localStorage-da — saxlanır ki, poll-lar onları silməsin
// və reload-dan sonra da qalsın. Səhifə bunları "system" tipində siyahıya qoşur.

export interface PosSystemNotification {
  id: string;
  title: string;
  message: string;
  rawTimeIso: string;
  isRead: boolean;
}

const KEY = 'pos_system_notifications';
const MAX = 50;
const EVENT = 'pos:system-notification';

function load(): PosSystemNotification[] {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? (JSON.parse(raw) as PosSystemNotification[]) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

function save(list: PosSystemNotification[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* localStorage dolu/əlçatmaz — səssiz keç */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT));
  }
}

/** Cari sistem bildirişləri (ən yeni öncə). */
export function getSystemNotifications(): PosSystemNotification[] {
  return load();
}

/** Yeni sistem bildirişi əlavə et (ən başa). */
export function addSystemNotification(input: { title: string; message: string }): void {
  const list = load();
  list.unshift({
    id: `sys-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    title: input.title,
    message: input.message,
    rawTimeIso: new Date().toISOString(),
    isRead: false,
  });
  save(list);
}

export function markSystemNotificationRead(id: string): void {
  save(load().map((n) => (n.id === id ? { ...n, isRead: true } : n)));
}

export function markAllSystemNotificationsRead(): void {
  save(load().map((n) => ({ ...n, isRead: true })));
}

export function removeSystemNotification(id: string): void {
  save(load().filter((n) => n.id !== id));
}

/** `sys-` prefiksi sistem-store bildirişini bildirir (səhifədə read/sil üçün). */
export function isSystemNotificationId(id: string): boolean {
  return typeof id === 'string' && id.startsWith('sys-');
}
